import { render, staticRenderFns } from "./AddPartyForm.vue?vue&type=template&id=ed963a0e&"
import script from "./AddPartyForm.vue?vue&type=script&lang=js&"
export * from "./AddPartyForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports